import { snackbarService } from '/common/snackbarService';
import { parseJSON } from '/helpers/json/parseJSON';
import { userProfileService } from '/api/domains';

import { createAppAsyncThunk } from '../../hooks';

import type { IUIState } from './state';

export const fetchUserSettings = createAppAsyncThunk('ui/fetchUserSettings', async (_res, api) => {
  const state = api.getState();

  const token = state.auth.tokens?.access;

  if (!token) {
    return api.rejectWithValue('No authorization token found');
  }
  try {
    const userSettingsRetrieve = await userProfileService.retrieveSettings();

    return userSettingsRetrieve.bifold(
      (res) => {
        if (res?.settings?.settings !== undefined) {
          return parseJSON<Pick<IUIState, 'isHints' | 'isSplashScreen'>>(res.settings.settings);
        }
        return null;
      },
      (err) => {
        throw err;
      }
    );
  } catch (e) {
    snackbarService.error(`Retrieve User Settings: ${(e as Error).message}`);
    console.error('user.settings$', e);

    return api.rejectWithValue((e as Error).message);
  }
});
